import React from 'react';

import { withFormsy } from 'formsy-react';
import { Input } from 'formsy-react-components';
import { i18n } from 'common';


export class AdminSecureInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = { type: 'password' }
  }

  onChangeType = () => {
    const { type } = this.state;

    this.setState({
      type: type === 'password'? 'text':'password'
    });
  }

  render() {
    const { type } = this.state;

    return (
      <div className="password-input">
        <Input {...this.props} type={type} layout="vertical" label="" />

        <a className="is-clickable" onClick={this.onChangeType}>
          <i className="icon fa fa-eye" />
        </a>
      </div>
    );
  }
};
